<section class="container">
  <span *ngIf="title" [mdkChangeTextWithColorAndImage]="title" class="title"></span>
  <section [class.items-container]="title">
    <ng-container *ngFor="let item of items">
      <mdk-timeline-item [item]="item" />
    </ng-container>
  </section>
</section>
